<template>
	<div>
		<v-container v-if="missingRecord">
			<v-row justify="center">
				<v-col cols="12" sm="8" md="6" lg="4">
					<v-card>
						<v-card-title primary-title>
							<v-spacer></v-spacer>
							<div>حصل خطا</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<v-row dense>
								<v-col cols="12" class="text-center">الرجاء التواصل مع الإدارة</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<v-container v-else-if="!isEdit || (isEdit && added)">
			<v-breadcrumbs :items="breadcrumbs">
				<template #divider>
					<v-icon>mdi-chevron-left</v-icon>
				</template>
			</v-breadcrumbs>
			
			<v-stepper v-model="step" :alt-labels="$vuetify.breakpoint.mdAndDown">
				<v-stepper-header>
					<v-stepper-step
						:editable="consent && step > 0"
						edit-icon="mdi-check"
						:complete="step > 1"
						step="1"
					>
						المعلومات الأساسية
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 2"
						step="2"
					>
						أماكن وفترات الفعالية
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 3"
						step="3"
					>
						بيانات الإتصال
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step
						:editable="consent && (isEdit || added)"
						edit-icon="mdi-check"
						:complete="step > 4"
						step="4"
					>
						المرفقات
					</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="0">
						<v-form v-model="valid0">
							<v-row dense>
								<v-col cols="12" class="text-center text-h5 pb-4">الإقرار</v-col>
								<v-col cols="12">
									<v-skeleton-loader v-if="!conditions" type="paragraph@2"></v-skeleton-loader>
									<pre v-else>{{ conditions }}</pre>
								</v-col>
								<v-col v-if="conditions" cols="12">
									<v-checkbox
										v-model="consent"
										hide-details="auto"
										label="أقر بأنني قرأت نص الإقرار المذكور أعلاه وأوافق على ذلك"
										:rules="[rules.required]"
									></v-checkbox>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :disabled="!valid0 || !conditions" @click="step = 1">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="1">
						<v-form v-model="valid1">
							<v-row no-gutters>
								<v-col cols="12" md="6" order="2" order-md="1">
									<v-row no-gutters>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="newRecord.title"
												outlined
												hide-details="auto"
												label="العنوان"
												:rules="[rules.required, rules.maxLength75]"
												counter="75"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="newRecord.description"
												outlined
												hide-details="auto"
												label="الوصف (اختياري)"
												:rules="[rules.maxLength150]"
												counter="150"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-combobox
												v-model="newRecord.organizers"
												:search-input.sync="search"
												:items="allOrganizers"
												outlined
												hide-details="auto"
												label="الجهات المنظمة"
												multiple
												chips
												deletable-chips
												:rules="[rules.required]"
											>
												<template v-if="!search" #prepend-item>
													<v-list-item>
														<v-list-item-content>
															<v-list-item-title>
																لإضافة جهة جديدة قم بكتابتها ثم الضغط على زر 
																<kbd>enter</kbd>
																<small>&nbsp;(زر إضافة السطور)</small>
															</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
													<v-divider class="mt-2"></v-divider>
												</template>
												<template #no-data>
													<v-list-item>
														<v-list-item-content>
															<v-list-item-title>
																لإضافة 
																"<strong>{{ search }}</strong>",
																قم بالضغط على زر <kbd>enter</kbd>
																<small>&nbsp;(زر إضافة السطور)</small>
															</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
												</template>
											</v-combobox>
										</v-col>
										<v-col cols="12" md="6" class="pa-2">
											<v-menu
												v-model="menu3"
												:close-on-content-click="false"
												:nudge-right="40"
												transition="scale-transition"
												offset-y
												min-width="290px"
											>
												<template #activator="{ on }">
													<v-text-field
														v-model="newRecord.startDate"
														outlined
														hide-details="auto"
														label="تاريخ بداية التسجيل"
														:rules="[rules.required]"
														readonly
														v-on="on"
													></v-text-field>
												</template>
												<v-date-picker
													v-model="newRecord.startDate"
													@input="menu3 = false"
												></v-date-picker>
											</v-menu>
										</v-col>
										<v-col cols="12" md="6" class="pa-2">
											<v-menu
												v-model="menu4"
												:close-on-content-click="false"
												:nudge-right="40"
												transition="scale-transition"
												offset-y
												min-width="290px"
											>
												<template #activator="{ on }">
													<v-text-field
														v-model="newRecord.endDate"
														outlined
														hide-details="auto"
														label="تاريخ نهاية التسجيل"
														:rules="[rules.required, rules.endDateAfterStartDate(newRecord.startDate, newRecord.endDate)]"
														readonly
														v-on="on"
													></v-text-field>
												</template>
												<v-date-picker
													v-model="newRecord.endDate"
													@input="menu4 = false"
												></v-date-picker>
											</v-menu>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-textarea
												v-model="newRecord.conditions"
												:rows="3"
												outlined
												hide-details="auto"
												label="الشروط"
												:rules="[rules.required, rules.maxLength500]"
												counter="500"
											></v-textarea>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-text-field
												v-model="newRecord.registerLink"
												outlined
												hide-details="auto"
												label="رابط التسجيل (اختياري)"
											></v-text-field>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-textarea
												v-model="newRecord.note"
												:rows="3"
												outlined
												hide-details="auto"
												label="التفاصيل (اختياري)"
												:rules="[rules.maxLength500]"
												counter="500"
											></v-textarea>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" md="6" order="1" order-md="2">
									<v-row no-gutters>
										<v-col cols="12" class="pa-2 text-center">
											<v-btn-toggle v-model="isPhone">
												<v-btn :value="true">
													<v-icon :left="isPhone">mdi-cellphone</v-icon>
													<span v-if="isPhone">طريقة العرض الطولية</span>
												</v-btn>

												<v-btn :value="false">
													<span v-if="!isPhone">طريقة العرض العرضية</span>
													<v-icon :right="!isPhone">mdi-laptop</v-icon>
												</v-btn>
											</v-btn-toggle>
										</v-col>
										<v-col cols="12" class="pa-2 text-center">
											<v-avatar
												color="grey lighten-5"
												height="200"
												tile
												:width="200 * (isPhone ? 1/1.4 : 1.4)"
												class="mt-1"
											>
												<v-img
													contain
													style="border: 1px dotted grey"
													:src="newRecord.attachment | imgToURL"
													:aspect-ratio="isPhone ? 1/1.4 : 1.4"
												>
													<v-spacer></v-spacer>
													<v-chip v-if="isEdit" tile style="opacity: 0.5;">الصورة الجديدة</v-chip>
													<v-spacer></v-spacer>
												</v-img>
											</v-avatar>

											<v-avatar
												v-if="isEdit"
												color="grey lighten-5"
												height="200"
												tile
												:width="200 * (isPhone ? 1/1.4 : 1.4)"
												class="mt-1"
											>
												<v-img
													contain
													style="border: 1px dotted grey"
													:src="oldRecord.attachment"
													:aspect-ratio="isPhone ? 1/1.4 : 1.4"
												>
													<v-spacer></v-spacer>
													<v-chip style="opacity: 0.5;" :href="oldRecord.attachment" target="_blank">
														الصورة السابقة
														<v-icon right>mdi-file-eye</v-icon>
													</v-chip>
													<v-spacer></v-spacer>
												</v-img>
											</v-avatar>
										</v-col>
										<v-col cols="12" class="pa-2" style="padding-top: 23px !important;">
											<v-file-input
												v-model="newRecord.attachment"
												:rules="isEdit ? [rules.max2mb, rules.optionalImage] : [rules.required, rules.max2mb, rules.optionalImage]"
												accept="image/*"
												show-size
												prepend-inner-icon="mdi-camera"
												prepend-icon
												label="صورة عرض الحدث"
												outlined
												hide-details="auto"
											></v-file-input>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" order="3">
									<v-row>
										<v-col cols="12" class="pa-2">الرعاة</v-col>
										<v-col v-for="(sponsor, index) in sponsors" :key="index" cols="12">
											<v-card>
												<v-card-text>
													<v-row no-gutters>
														<v-col cols="12" md="4" order="1" order-md="2" class="pa-4">
															<v-img contain :src="sponsor.image" height="100%" max-height="250"></v-img>
														</v-col>
														<v-col cols="12" md="8" order="2" order-md="1">
															<v-row dense>
																<v-col cols="6">
																	الراعي #{{ index + 1 }}:
																</v-col>
																<v-col cols="6" class="text-end">
																	<v-icon color="error" @click="removeSponsor(index)">mdi-close</v-icon>
																</v-col>
																<v-col cols="12">
																	<v-autocomplete v-model="sponsor.sponsor" outlined hide-details="auto" label="اختيار راعي من الشركات" :items="companies" return-object item-text="name" clearable @change="setCompanyAsSponsor(sponsor)"></v-autocomplete>
																</v-col>
																<v-col cols="12">
																	<v-text-field v-model="sponsor.name" outlined hide-details="auto" label="اسم الراعي" :rules="[rules.required]"></v-text-field>
																</v-col>
																<v-col cols="12">
																	<v-text-field v-model.trim="sponsor.link" outlined hide-details="auto" label="رابط الراعي" :rules="[rules.required, rules.link]" dir="ltr"></v-text-field>
																</v-col>
																<v-col cols="12">
																	<v-text-field v-model.trim="sponsor.image" outlined hide-details="auto" label="رابط صورة الراعي" :rules="[rules.required, rules.link]" dir="ltr"></v-text-field>
																</v-col>
																<!-- <v-col cols="12">
																	<v-text-field v-model="sponsor.type" outlined hide-details="auto" label="نوع الراعي" :rules="[rules.required]"></v-text-field>
																</v-col> -->
															</v-row>
														</v-col>
													</v-row>
												</v-card-text>
											</v-card>
										</v-col>
										<v-col cols="12" class="pa-2">
											<v-btn color="primary" @click="addSponsor">
												إضافة راعي جديد
												<v-icon right>mdi-account-multiple-plus</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" class="pa-2 text-center" order="4">
									<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="submitStep1">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="2">
						<v-form v-model="valid4">
							<v-row no-gutters>
								<v-col cols="12" class="px-2">
									<v-checkbox v-model="online" label="فعالية عن بعد" hide-details></v-checkbox>
								</v-col>
								
								<app-location-selector v-show="!online" ref="locations" v-model="newSession" :online="online"></app-location-selector>

								<v-col cols="12" class="pa-2">
									<v-text-field
										v-model="newSession.locationDetails"
										outlined
										hide-details="auto"
										:label="online ? 'رابط الفعالية (عن بعد) (اختياري)' : 'تفاصيل الموقع (اختياري)'"
										:rules="[rules.maxLength250, !online || rules.optionalLink]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-textarea
										v-model="newSession.description"
										:rows="3"
										outlined
										hide-details="auto"
										label="وصف الفعالية (اختياري)"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-textarea>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-menu
										v-model="menu3_1"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="newSession.startDate"
												outlined
												hide-details="auto"
												label="تاريخ بداية الفترة"
												:rules="[rules.required]"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker
											v-model="newSession.startDate"
											@input="menu3_1 = false"
										></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-menu
										v-model="menu3_2"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="newSession.endDate"
												outlined
												hide-details="auto"
												label="تاريخ نهاية الفترة"
												:rules="[rules.required, rules.endDateAfterStartDate(newSession.startDate, newSession.endDate)]"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker
											v-model="newSession.endDate"
											@input="menu3_2 = false"
										></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-menu
										v-model="menu3_3"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="newSession.startTime"
												outlined
												hide-details="auto"
												label="وقت بداية الفترة (اختياري)"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-time-picker v-model="newSession.startTime" ampm-in-title :landscape="$vuetify.breakpoint.smAndUp"></v-time-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-menu
										v-model="menu3_4"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
										min-width="290px"
									>
										<template #activator="{ on }">
											<v-text-field
												v-model="newSession.endTime"
												outlined
												hide-details="auto"
												label="وقت نهاية الفترة (اختياري)"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-time-picker v-model="newSession.endTime" ampm-in-title :landscape="$vuetify.breakpoint.smAndUp"></v-time-picker>
									</v-menu>
								</v-col>

								<v-col cols="12" class="pa-2 text-center">
									<template v-if="!online">
										<v-btn color="success" :loading="loading" :disabled="!valid4 || !newSession.place" @click="addNewSession">
											إضافة
											<v-icon right>mdi-plus</v-icon>
										</v-btn>
									</template>
									<template v-else>
										<v-btn color="success" :loading="loading" :disabled="!valid4" @click="addNewSession">
											إضافة
											<v-icon right>mdi-plus</v-icon>
										</v-btn>
									</template>
								</v-col>
								
								<v-col cols="12" class="pa-2">
									<v-row dense class="pt-2">
										<v-col v-for="item in sessions" :key="item.startDate" cols="12" md="6" xl="4">
											<v-card class="pa-1" outlined>
												<v-card-title v-if="item.placeID == 1" class="text-body-1 pb-1 pt-2">
													عن بعد
													<v-spacer></v-spacer>
													<v-btn text icon color="primary" :href="item.locationDetails" target="_blank">
														<v-icon>mdi-laptop</v-icon>
													</v-btn>
													<v-btn text icon color="error" @click="removeSession(item.id)">
														<v-icon>mdi-delete</v-icon>
													</v-btn>
												</v-card-title>
												<v-card-title v-else class="text-body-1 pb-1 pt-2">
													{{ item.cityName }} - {{ item.placeName }}
													<v-spacer></v-spacer>
													<v-btn text icon color="primary" :href="item.locationLink" target="_blank">
														<v-icon>mdi-map-marker</v-icon>
													</v-btn>
													<v-btn text icon color="error" @click="removeSession(item.id)">
														<v-icon>mdi-delete</v-icon>
													</v-btn>
												</v-card-title>
												<v-card-text>
													<v-divider></v-divider>
													<v-row dense>
														<v-col v-if="item.placeID == 1" cols="12">
															<v-row dense>
																<v-col cols="auto">
																	<b>رابط المحاضرة:</b>
																</v-col>
																<v-col v-if="item.locationDetails" class="text-end">
																	<a
																		:href="item.locationDetails"
																		target="_blank"
																		rel="noopener noreferrer"
																	>{{ item.locationDetails }}</a>
																</v-col>
															</v-row>
														</v-col>
														<v-col v-else-if="item.locationDetails" cols="12">
															<v-row dense>
																<v-col cols="auto">
																	<b>تفاصيل الموقع:</b>
																</v-col>
																<v-col class="text-end">{{ item.locationDetails }}</v-col>
															</v-row>
														</v-col>
														<v-col cols="12">
															<v-row dense>
																<v-col cols="auto">
																	<b>تاريخ الفترة:</b>
																</v-col>
																<v-col class="text-end">{{ item.startDate }} ~ {{ item.endDate }}</v-col>
															</v-row>
														</v-col>
														<v-col cols="12">
															<v-row dense>
																<v-col cols="auto">
																	<b>وقت الفترة:</b>
																</v-col>
																<v-col class="text-end">{{ item.startTime }} ~ {{ item.endTime }}</v-col>
															</v-row>
														</v-col>
														<v-col cols="12">{{ item.description }}</v-col>
													</v-row>
												</v-card-text>
											</v-card>
										</v-col>
									</v-row>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :loading="loading" @click="step = 3">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="3">
						<v-form>
							<v-row no-gutters>
								<v-col cols="12" md="6" class="pa-2">
									<v-select
										v-model="newCommunication.type"
										outlined
										hide-details="auto"
										label="نوع الإتصال"
										:items="contactTypes"
										item-value="communicationTypeID"
										item-text="name"
									></v-select>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-text-field
										v-model="newCommunication.value"
										outlined
										hide-details="auto"
										label="المعرف"
										class="ltr-content"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-textarea
										v-model="newCommunication.note"
										:rows="3"
										outlined
										hide-details="auto"
										label="ملاحظة (اختياري)"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-textarea>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="success"
										:loading="loading"
										:disabled="!newCommunication.type || !newCommunication.value"
										@click="addContact"
									>
										إضافة
										<v-icon right>mdi-plus</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-data-table hide-default-footer :headers="step4Headers" :items="communications">
										<template #[`item.delete`]="{ item }">
											<v-tooltip bottom>
												<template #activator=" {on} ">
													<v-btn icon medium :disabled="loading" v-on="on" @click="deleteCommunication(item.id)">
														<v-icon color="error">mdi-comment-remove</v-icon>
													</v-btn>
												</template>
												<span>حذف</span>
											</v-tooltip>
										</template>
									</v-data-table>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" :loading="loading" @click="step = 4">حفظ</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>

					<v-stepper-content step="4">
						<v-form v-model="valid3">
							<v-row no-gutters>
								<v-col cols="12" md="6" class="pa-2">
									<v-text-field
										v-model="newAttachment.name"
										outlined
										hide-details="auto"
										label="اسم الملف"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="pa-2">
									<v-text-field
										v-model="newAttachment.description"
										outlined
										hide-details="auto"
										label="الوصف (اختياري)"
										:rules="[rules.maxLength250]"
										counter="250"
									></v-text-field>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-file-input
										v-model="newAttachment.attachment"
										outlined
										hide-details="auto"
										label="الملف"
										prepend-icon
										prepend-inner-icon="mdi-file-upload"
										:rules="[rules.max2mb]"
										show-size
									></v-file-input>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn
										color="success"
										:loading="loading"
										:disabled="!newAttachment.name || !newAttachment.attachment || !valid3"
										@click="uploadAttachment"
									>
										إضافة
										<v-icon right>mdi-plus</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="12" class="pa-2">
									<v-data-table hide-default-footer :headers="step5Headers" :items="attachments">
										<template #[`item.attachment`]="{ }">
											<v-tooltip bottom>
												<template #activator=" {on} ">
													<v-btn icon medium v-on="on" @click=";">
														<v-icon medium>mdi-file-download</v-icon>
													</v-btn>
												</template>
												<span>تحميل</span>
											</v-tooltip>
										</template>

										<template #[`item.delete`]="{ item }">
											<v-tooltip bottom>
												<template #activator=" {on} ">
													<v-btn icon medium v-on="on" @click=";">
														<v-icon medium color="red" @click="removeAttachment(item.id)">mdi-file-remove</v-icon>
													</v-btn>
												</template>
												<span>حذف</span>
											</v-tooltip>
										</template>
									</v-data-table>
								</v-col>
								<v-col cols="12" class="pa-2 text-center">
									<v-btn color="primary" class="mx-2 mb-2" :loading="loading" @click="submit">حفظ وإرسال</v-btn>
									<v-btn color="primary" class="mx-2 mb-2" :loading="loading" @click="saveDraft">حفظ كمسودة</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-container>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import { addBaseURL } from "@/utils/baseURL";
import { toHijri } from "hijri-converter";
import AppLocationSelector from "@/components/AppLocationSelector";

export default {
	filters: {
		imgToURL(val) {
			if (val) return URL.createObjectURL(val);
			return "";
		}
	},
	components:{
		AppLocationSelector
	},
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			search: null,
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					to: { name: "dashboard-home" }
				},
				{
					text: "الفعاليات",
					exact: true,
					to: { name: "dashboard-events" }
				},
				{
					text: "الإضافة",
					disabled: true
				}
			],
			consent: false,
			loading: false,
			step: 0,
			step3Headers: [
				{ text: "الدولة", value: "country" },
				{ text: "المنطقة", value: "region" },
				{ text: "المدينة", value: "city" },
				{ text: "المكان", value: "place" },
				{ text: "تفاصيل الموقع", value: "locationDetails" },
				{ text: "الوصف", value: "description" },
				{ text: "تاريخ البدء", value: "startDate" },
				{ text: "تاريخ الانتهاء", value: "endDate" },
				{ text: "وقت البدء", value: "startTime" },
				{ text: "وقت النهاية", value: "endTime" }
			],
			step4Headers: [
				{ value: "communicationType", text: "نوع الإتصال" },
				{ value: "value", text: "المعرف" },
				{ value: "note", text: "ملاحظة" },
				{ value: "delete", text: "حذف", sortable: false }
			],
			step5Headers: [
				{ text: "اسم الملف", value: "name" },
				{ text: "الوصف", value: "description" },
				{ text: "فتح الملف", value: "attachment" },
				{ text: "حذف الملف", value: "delete", sortable: false },
			],
			newRecord: {
				title: "",
				description: "",
				attachment: null,
				startDate: "",
				endDate: "",
				note: "",
				conditions: "",
				registerLink: null
			},
			recordID: 1,
			companies: [],
			valid0: false,
			valid1: false,
			valid2: false,
			valid3: false,
			valid4: false,
			menu2: false,
			menu3: false,
			menu4: false,
			menu3_1: false,
			menu3_2: false,
			menu3_3: false,
			menu3_4: false,
			recordCities: {
				region: null,
				country: null,
				cities: []
			},
			conditions: null,
			newAttachment: {
				name: null,
				attachment: null,
				description: null
			},
			attachments: [],
			contactTypes: [],
			communications: [],
			newCommunication: {
				value: null,
				type: null,
				note: null
			},
			isPhone: true,
			allOrganizers: [],
			isEdit: false,
			oldRecord: {},
			missingRecord: false,
			added: false,
			sponsors: [],

			newSession: {
				country: null,
				region: null,
				city: null,
				place: null,
				locationDetails: null,
				description: null,
				startDate: null,
				endDate: null,
				startTime: null,
				endTime: null
			},
			sessions: [],
			online: false,
		};
	},
	watch: {
		step () {
			this.$vuetify.goTo(0);
		},
		"newRecord.startDate"(newVal) {
			var newDate = newVal.split("-");
			var hijri = toHijri(
				Number(newDate[0]),
				Number(newDate[1]),
				Number(newDate[2])
			);
			var date =
				("" + hijri.hy).padStart(4, 0) +
				"-" +
				("" + hijri.hm).padStart(2, 0) +
				"-" +
				("" + hijri.hd).padStart(2, 0);
			this.newRecord.hijriDate = date;
		},
		"newCommunication.type"(newVal) {
			if (newVal) {
				var type = this.contactTypes.find(
					com => com.communicationTypeID == this.newCommunication.type
				);
				if (type.initialProfilesPath == null) {
					type.initialProfilesPath = "";
				}
				this.newCommunication.value = "" + type.initialProfilesPath;
			}
		},
		recordID() {
			this.getContactTypes();
		},
		communications() {
			this.contactTypes = [];
			this.getContactTypes();
		},
		"newRecord.organizers"(newVal) {
			if (newVal && newVal.length) {
				var newItem = newVal[newVal.length - 1];
				if (this.allOrganizers.indexOf(newItem) == -1) {
					this.allOrganizers.push(newItem);
				}
			}
		},
	},
	mounted() {
		if (this.$route.params.recordID) {
			console.log("edit");
			this.isEdit = true;
			this.recordID = this.$route.params.recordID;
			this.consent = true;
			this.step = 1;
		} else {
			console.log("not edit");
		}

		if (!this.isEdit) {
			this.getConditions();
		}
		this.getCompanies();

		if (this.isEdit) {
			this.getPreviousInfo();
		}
	},
	methods: {
		getPreviousInfo() {
			client
				.get("/api/events/show/" + this.recordID)
				.then(response => {
					console.log(response);
					var newData = response.data.data;
					newData.coverPic = addBaseURL(newData.coverPic);

					if (newData.communications) {
						newData.communications = newData.communications.map(
							comm => {
								if (comm.note == "null") {
									comm.note = null;
								}
	
								if (comm.name == "Telephone") {
									comm.value = "tel:" + comm.value;
								} else if (comm.name == "رقم الجوال") {
									comm.value = "tel:" + comm.value;
								} else if (comm.name == "البريد الإلكتروني") {
									comm.value = "mailto:" + comm.value;
								}
								return comm;
							}
						);
					}

					this.newRecord = newData;

					if (this.newRecord.attachments) {
						this.attachments = this.newRecord.attachments;
					}

					if (this.newRecord.communications) {
						this.communications = this.newRecord.communications.map(
							e => {
								e.communicationType = e.name;
								return e;
							}
						);
					}

					this.oldRecord = { ...newData };
					this.oldRecord.attachment = this.oldRecord.coverPic;

					this.sponsors = newData.sponsers;
					if (this.sponsors.length == 0) {
						this.addSponsor();
					}

					if (this.newRecord.places) {
						this.sessions = this.newRecord.places;
					}

					if (this.newRecord.description == "null") {
						this.newRecord.description = null;
					}

					this.added = true;
					setTimeout(() => {
						// on next tick, 0ms is enough
						this.valid1 = true;
					}, 100);
				})
				.catch(err => {
					this.missingRecord = true;
					console.log(err);
				});
		},
		getConditions() {
			client
				.get("/api/events/conditions")
				.then(response => {
					this.conditions = response.data;
					this.conditions = this.conditions || "...";
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		submitStep1() {
			this.loading = true;
			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			var data = new FormData();
			data.append("title", this.newRecord.title);
			
			if (this.newRecord.description) {
				data.append("description", this.newRecord.description);
			} else {
				data.append("description", null);
			}

			data.append("startDate", this.newRecord.startDate);
			data.append("endDate", this.newRecord.endDate);
			data.append("conditions", this.newRecord.conditions);
			data.append(
				"organizers",
				JSON.stringify(this.newRecord.organizers)
			);
			data.append("sponsors", JSON.stringify(this.sponsors));
			data.append("sponsers", JSON.stringify(this.sponsors));

			if (this.newRecord.attachment) {
				data.append("attachment", this.newRecord.attachment);
			}

			if (this.newRecord.note) {
				data.append("note", this.newRecord.note);
			}

			if (this.newRecord.registerLink) {
				data.append("registerLink", this.newRecord.registerLink);
			}

			if (this.isEdit) {
				data.append("eventID", this.recordID);
				client
					.post("/api/events/update", data, config)
					.then(response => {
						this.step = 2;
						console.log(response);
					})
					.catch(err => {
						console.log(err);
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				client
					.post("/api/events/insert", data, config)
					.then(response => {
						this.step = 2;
						this.recordID = response.data.data.id;
						this.isEdit = true;
						this.added = true;
						console.log(response);
					})
					.catch(err => {
						console.log(err);
					})
					.finally(() => {
						this.loading = false;
					});
			}
		},
		uploadAttachment() {
			this.loading = true;
			var data = new FormData();
			data.append("eventID", this.recordID);
			data.append("name", this.newAttachment.name);
			data.append("description", this.newAttachment.description);
			data.append("attachment", this.newAttachment.attachment);

			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				}
			};

			client
				.post("/api/events/addAttachment", data, config)
				.then(response => {
					var insertedAttachment = { 
						id: response.data.data.id,
						name: response.data.data.name,
						description: response.data.data.description,
						attachment: addBaseURL(response.data.data.path),
					};
					this.attachments.push(insertedAttachment);
					this.newAttachment = {
						name: null,
						description: null,
						attachment: null
					};
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getContactTypes() {
			this.contactTypes = [];
			
			client
				.get("/api/events/allowconntype/" + this.recordID)
				.then(response => {
					this.contactTypes = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		addContact() {
			this.loading = true;
			var data = new FormData();
			data.append("eventID", this.recordID);
			data.append("communicationTypeID", this.newCommunication.type);
			data.append("value", this.newCommunication.value);
			data.append("note", this.newCommunication.note);

			client
				.post("/api/events/newCommunication", data)
				.then(response => {
					var type = this.contactTypes.find(
						com =>
							com.communicationTypeID ==
							this.newCommunication.type
					);
					this.communications.push({
						...this.newCommunication,
						communicationType: type.name,
						id: response.data.data.id
					});
					this.newCommunication = {
						value: null,
						type: null,
						note: null
					};
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		deleteCommunication(comID) {
			this.loading = true;

			client
				.delete("/api/communication/delete/" + comID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.communications.findIndex(
						com => com.id == comID
					);
					this.communications.splice(index, 1);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		saveDraft() {
			this.$router.push({ name: "dashboard-events-manage" });
			// this.loading = true;
			// client
			// 	.post("/api/events/saveDraft/" + this.recordID)
			// 	.then(response => {
			// 		this.$store.dispatch("notify", {
			// 			message: "تم الحفظ كمسودة"
			// 		});
			// 		this.$router.push({ name: "dashboard-events-manage" });
			// 		console.log(response);
			// 	})
			// 	.catch(err => {
			// 		console.log(err);
			// 	})
			// 	.finally(() => {
			// 		this.loading = false;
			// 	});
		},
		submit() {
			this.loading = true;
			client
				.post("/api/events/submit/" + this.recordID)
				.then(response => {
					this.$store.dispatch("notify", {
						message: "تم الحفظ والإرسال"
					});
					this.$router.push({ name: "dashboard-events-manage" });
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		addSponsor() {
			this.sponsors.push({
				name: "",
				link: "",
				image: "",
				type: ""
			})
		},
		removeSponsor(index) {
			this.sponsors.splice(index, 1);
		},
		removeAttachment(attachmentID){
			this.loading = true;

			client
				.delete("/api/attachment/delete/" + attachmentID)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.attachments.findIndex(
						attachment => attachment.id == attachmentID
					);
					this.attachments.splice(index, 1);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		addNewSession() {
			this.loading = true;
			if (this.online) {
				this.newSession.place = 1;
			}

			console.log(this.online);

			var data = {
				eventID: this.recordID,
				placeID: this.newSession.place,
				locationDetails: this.newSession.locationDetails,
				description: this.newSession.description,
				startDate: this.newSession.startDate,
				endDate: this.newSession.endDate,
				startTime: this.newSession.startTime,
				endTime: this.newSession.endTime
			};

			client
				.post("/api/events/addPlace", data)
				.then(response => {
					var oldSession;
					if (this.online) {
						oldSession = {
							...this.newSession,
							id: response.data.id,
							placeID: this.newSession.place,
							countryName: "اونلاين",
							cityName: "اونلاين",
							regionName: "اونلاين",
							placeName: "اونلاين"
						};
					} else {
						oldSession = {
							...this.newSession,
							id: response.data.id,
							placeID: this.newSession.place,
							countryName: this.$refs.locations.countries.find(
								c => c.countryID == this.newSession.country
							).name,
							cityName: this.$refs.locations.cities.find(
								c => c.cityID == this.newSession.city
							).name,
							regionName: this.$refs.locations.regions.find(
								r => r.regionID == this.newSession.region
							).name,
							placeName: this.$refs.locations.places.find(
								p => p.id == this.newSession.place
							).name
						};
					}

					this.sessions.push(oldSession);
					this.newSession = {
						...this.newSession,
						description: null
					};
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		removeSession(sessionID) {
			this.loading = true;

			var data = {
				eventID: this.recordID,
				id: sessionID
			};

			client
				.delete("/api/events/removePlace", { params: data })
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");

					var index = this.sessions.findIndex(
						session => session.id == sessionID
					);
					this.sessions.splice(index, 1);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getCompanies() {
			client
				.get("/api/companies/all")
				.then(response => {
					this.companies = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		setCompanyAsSponsor(sponsor) {
			if (sponsor.sponsor) {
				sponsor.name = sponsor.sponsor.name;
				sponsor.link = sponsor.sponsor.webLink || "";
				sponsor.image = sponsor.sponsor.logoPath;
			}
		}
	}
};
</script>

<style scoped>
.ltr-content ::v-deep input {
	direction: ltr;
}
</style>